import * as Cesium from 'cesium';
import {FeatureCollection} from '@turf/turf';
import {getCameraBoundingBox, toIGNBBoxString} from '../../cesiumTools';
import {LayerDatasource, LayerLoadType, MapperViewer} from '../../types';

export class RailwayCIVLayer implements LayerDatasource {

  id = 'railway_civ';
  name = 'Chemin de fer';
  active = true;
  dataSource = new Cesium.GeoJsonDataSource(this.name);
  loadType = LayerLoadType.Manual;
  viewer: MapperViewer;
  showLabel = false;
  isLoading = false;

  /* Custom properties */
  url = 'https://mapserver-v2.predictservices.ws/wfs?\n' +
    'SERVICE=WFS&REQUEST=GetFeature&VERSION=2.0.0&TYPENAMES=ms:civ_TRONCON_VOIE_FERREE_wfs&STARTINDE\n' +
    'X=0&COUNT=10000&SRSNAME=urn:ogc:def:crs:EPSG::4326&OUTPUTFORMAT=geojson&BBOX='


  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.dataSources.add(this.dataSource);
  }

  remove(): void {
    this.viewer.dataSources.remove(this.dataSource);
  }

  loadData(): void {
    if (!this.dataSource) {
      console.error('Viewer not initialized');
      return;
    }

    const bbox = toIGNBBoxString(getCameraBoundingBox(this.viewer));

    if (bbox) {
      this.isLoading = true;

      const url = `${this.url}${bbox},urn:ogc:def:crs:EPSG::4326`;
      fetch(url)
        .then(res => res.json())
        .then((res: FeatureCollection) => {
          this.buildRoad(res);
        }).catch(error => {
          console.error('[RailwayCIVLayer] -> (error) -> ', error);
          this.isLoading = false;
        });
    }
  }

  buildRoad(geojson: FeatureCollection): void {
    this.dataSource.load(geojson, {
      clampToGround: true,
    }).then(() => {
      this.dataSource.entities.values.forEach(road => {
        if (road.polyline) {
          road.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
            color: Cesium.Color.fromCssColorString('#953839'),
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 1
          });
          road.polyline.width = new Cesium.ConstantProperty(7);
        }
      });

      this.isLoading = false;
    });
  }

  setActive(active: boolean): void {
    this.active = active;
    this.dataSource.show = active;
  }


  onAfterPrint(): void {
  }

  onBeforePrint(): void {
  }
}
